import React from "react";
import PropTypes from "prop-types";
import LoadingAnimation from "../LoadingAnimation";

function Placeholder({ paddingTop = "80%", style = {} }) {
  return (
    <div
      style={{
        position: "relative",
        gridColumnEnd: -2,
        paddingTop: paddingTop,
        ...style,
      }}
    >
      <LoadingAnimation />
    </div>
  );
}

Placeholder.displayName = "Teaser.Placeholder";

Placeholder.propTypes = {
  paddingTop: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  show: PropTypes.bool,
  style: PropTypes.object,
};

export default Placeholder;
